import { useTranslation } from "react-i18next";
import { Award } from "lucide-react";

interface FoundingPartnerBadgeProps {
  readonly active: boolean;
  readonly testId?: string;
}

/**
 * Account-level Founding Partner recognition pill (ADR-0010 §9). A text /
 * placeholder badge for now — the guest-facing artwork is a follow-up.
 * Renders nothing when the account isn't a partner so call sites can mount it
 * unconditionally.
 */
export function FoundingPartnerBadge({ active, testId }: FoundingPartnerBadgeProps) {
  const { t } = useTranslation();
  if (!active) return null;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1 rounded-full border border-amber-300/60 bg-amber-50 px-2 py-0.5 font-sans text-xs font-medium text-amber-800"
    >
      <Award className="h-3 w-3" aria-hidden="true" />
      {t("founding.partner.badge")}
    </span>
  );
}
